import { useEffect } from 'react';
import {connect} from 'react-redux';
import {changeCursorSize} from "../../actions/CursorActions";
import {burgerClose} from "../../actions/BurgerActions";
import {DEFAULT_CURSOR_SIZE} from "../../constants/cursorConstants";

function SetCursor(props) {
    const { dispatch } = props;

    useEffect(() => {
        dispatch(changeCursorSize(DEFAULT_CURSOR_SIZE));
        dispatch(burgerClose());
    }, [dispatch]);

    return null;
};

export default connect()(SetCursor);